const AdviserExportIntegrationTypeEnum = Object.freeze({
    SPRINT_IO: 'SPRINT_IO'
});

export default AdviserExportIntegrationTypeEnum;
